import React, {useMemo} from 'react';
import {useEventSettings} from '../../../../../../data/hooks/events/useEventSettings';
import {useI18n} from '../../../../../../data/hooks/i18nHooks';
import {useEventSchedule} from '../../../../../../data/hooks/schedule/useEventSchedule';
import StartNetworkingStep from '../../../StartNetworkingStep/StartNetworkingStep';

function StepSelectableSessions(props) {
    const {eventId} = props,
        i18n = useI18n(),
        settings = useEventSettings(eventId),
        selectableSessions = useEventSchedule(eventId, {filter: session => session.is_selectable}),
        hasSelectable = selectableSessions.length > 0,
        hasSelected = useMemo(() => {
            return !!selectableSessions.some(session => session.is_selected);
        }, [selectableSessions]);

    return (
        <StartNetworkingStep visible={hasSelectable && settings.workshop_selection} href={['/events', eventId, 'schedule'].join('/')} done={hasSelected}>
            {i18n['start.select_sessions']}
        </StartNetworkingStep>
    );
}

export default StepSelectableSessions;
